import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useT } from "@/lib/i18n";

const SectionCTA = ({
  title,
  body,
  primaryLabel,
  primaryTo = "/contacto",
}) => {
  const t = useT();
  const finalTitle = title || t("cta.startTalking.title");
  const finalBody = body || t("cta.startTalking.body");
  const finalLabel = primaryLabel || t("cta.startTalking.button");
  const isExternal = primaryTo.startsWith("mailto:") || primaryTo.startsWith("http") || primaryTo.startsWith("tel:");
  const Wrapper = isExternal ? "a" : Link;
  const wrapperProps = isExternal ? { href: primaryTo } : { to: primaryTo };

  return (
  <section className="bg-sand/40 grain">
    <div className="max-w-[1200px] mx-auto px-6 md:px-12 py-24 md:py-32 text-center">
      <p className="text-[11px] tracking-[0.3em] uppercase text-sage mb-6">{t("nav.contact")}</p>
      <h2 className="font-serif text-4xl md:text-6xl leading-[1.05] text-charcoal max-w-3xl mx-auto">
        {finalTitle}
      </h2>
      <p className="mt-6 text-charcoal/70 max-w-xl mx-auto text-lg leading-relaxed">{finalBody}</p>
      <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
        <Wrapper
          {...wrapperProps}
          data-testid="section-cta-primary"
          className="group inline-flex items-center justify-center gap-2 bg-charcoal text-ivory rounded-full px-8 py-4 text-sm font-medium hover:bg-terracotta transition-all"
        >
          {finalLabel}
          <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
        </Wrapper>
      </div>
    </div>
  </section>
  );
};

export default SectionCTA;
